// Mirrors backend/roles.py. The server enforces every permission; this only
// decides what the admin UI shows.
export const STAFF_ROLES = ["admin", "manager", "order_manager", "finance", "catalog_manager", "marketing", "support"];
export const isStaff = (user) => !!user && (user.is_staff || STAFF_ROLES.includes(user.role));
export const can = (user, perm) => {
  if (!isStaff(user)) return false;
  if (user.role === "admin") return true;
  return !perm || (user.permissions || []).includes(perm);
};
